import { getTranslation } from 'app/core/http';

/**
 * To get the translation of the survey with specific language.
 */
export async function initialTranslation(surveyHash: string, language: string) {
  try {
    return await getTranslation(surveyHash, language);
  } catch (error) {
    throw error;
  }
}
